import store from '@/store'
export default async (to, from, next, router) => {
    if (!store.getters['auth/isAuthenticated'] && store.getters['auth/token']) {
        next({ name: 'login' });
    }
    next()
}

